import { SVG, SVGProps } from './svg'

export function IconRestore(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M22 12a9 9 0 0 1-9 9 8.89 8.89 0 0 1-5.16-1.63.51.51 0 0 1-.21-.37.5.5 0 0 1 .14-.39l.72-.73a.5.5 0 0 1 .63-.06A6.91 6.91 0 0 0 13 19a7 7 0 1 0-7-7h2.36a.49.49 0 0 1 .36.15l.2.2a.5.5 0 0 1 0 .71L5.39 16.6a.51.51 0 0 1-.71 0l-3.53-3.54a.5.5 0 0 1 0-.71l.2-.2a.49.49 0 0 1 .36-.15H4a9 9 0 0 1 18 0Z" />
    </SVG>
  )
}
